import React, { useEffect, useState } from "react";
import classes from './CCTVIntegrationsList.module.css'
import DataManager from "../../hooks/DataManager";
import ListCard from "../../components/GridList/ListCard";
import BasicTable from "../../components/Table/Table/Table";
import GridPaginationControls from "../../components/Table/Table/GridPaginationControls";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import { useDispatch, useSelector } from 'react-redux';
import Button1 from "../../components/UI/Button/Button1";
import { Await, Link, useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import useSetCookie from "../../components/hooks/UseSetCookie";
import { serviceActions } from "../../store/service-Slice";
import SearchBar from "../SearchView/Search/SearchBar";
import { getGroups, setSiteActive } from "../../Api Methods/Api";
import hikLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png'
import dahuaLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png'
import ajaxLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png'
import aiboxLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png'
import { id } from "date-fns/locale";
import Pill_Widget_2 from "../../components/UI/Widgets/Pill_Widget_2";
import { color } from "@mui/system";
import { InputSwitch } from "primereact/inputswitch";
import yellowWarn from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import amberWarn from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/amber_warn.png'
import redWarn from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'
import { red } from "@mui/material/colors";


const CCTVIntegrationsList = ({ sites, setSites }) => {
    const [integrations, setIntegrations] = useState(sites);
    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const apiData = {
        token,
        client
    }

    const dataManager = new DataManager();
    const [searchTerm, setSearchTerm] = useState("");
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const navigate = useNavigate();

    useEffect(() => {
        setPageIndex(1);
    }, [sites]);
    const dispatch = useDispatch();
    const HandleUipiodOnClick = (DeviceUUID) => {
        if (DeviceUUID){
            dispatch(serviceActions.setDeviceUUID(DeviceUUID));
            navigate("/Dashboard/SiteView/" + DeviceUUID); 
        }
        useSetCookie("DeviceUUID", DeviceUUID, 1);
    }
    const [groups, setGroups] = useState([])

    useEffect(() => {
        const GetGroups = async () => {
            const groups = await getGroups(apiData, dispatch)
            setGroups(groups)
        }

        GetGroups();
    }, [])

      const HandleSingleDeactivateSite = async (row) => {
        let body = {
          uuid: row.uuid,
          active: row.active == 1 ? 0 : 1
        };
    
        const response = await setSiteActive(apiData, body, dispatch);
        if (response.success){
          setSites((prevSites) =>
            prevSites.map((device) =>
                device.uuid === body.uuid ? { ...device, active: body.active } : device
            )
          );
        }
      }
    

    const HandleGroupOnClick = (groupName) => {
        const groupClicked = groups.find(g => g.name === groupName);
        if (groupClicked) {
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate("/Dashboard/Groups/GroupSites")
        }
    }

    const getDeviceStatus = (missedPolls) => {
        if (missedPolls == 1) return "Connectivity issue detected";
        if (missedPolls == 2) return "Frequent connection issues";
        if (missedPolls >= 3) return "Device offline or unresponsive";
        return "Device stable";
    }

    let tableColumns = [
        {
            id:"test",
            meta: { style: { width: "60px", minWidth: "60px" } },
            header: () => <div style={{ width: "20px" }}></div>,
            cell: (row) => {
                let logo = ""
                switch (row.row.original.integrationType){
                    case "HIKVISION": 
                        logo = hikLogo
                        break;
                    case "DAHUA":
                        logo = dahuaLogo
                        break;
                    case "AJAX": 
                        logo = ajaxLogo
                        break;
                    case "AIBOX":
                        logo = aiboxLogo
                        break;
                }
                const POLL_INTERVAL_MINUTES = 10;

                const offlineMs = row.row.original.missed_polls * POLL_INTERVAL_MINUTES * 60 * 1000;
                const offlineSinceDate = new Date(Date.now() - offlineMs).toLocaleDateString()

   
                return (
                    <div
                      style={{ maxWidth: "85px", display: "flex", flexDirection: "column", alignItems:"flex-start"}}
                      onClick={() => HandleUipiodOnClick(row.row.original.uuid)}
                    >
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        {row.row.original.missed_polls > 0 && (
                          <img
                            src={
                              row.row.original.missed_polls === 1
                                ? yellowWarn
                                : row.row.original.missed_polls === 2
                                ? amberWarn
                                : redWarn
                            }
                            style={{ width: "20px", height: "20px", marginRight: "10px" }}
                            title={getDeviceStatus(row.row.original.missed_polls)}
                          />
                        )}
                  
                        <img
                          style={{ width: "25px", height: "25px" }}
                          src={logo}
                        />
                      </div>
                  
                      {row.row.original.missed_polls > 0 && (
                        <p
                          style={{
                            color: "#6e6e6e",
                            fontSize: "9px",
                            marginTop: "2px",
                            textAlign: "center",
                            fontWeight: 500,
                          }}
                        >
                          {offlineSinceDate}
                        </p>
                      )}
                    </div>
                  );
                  
            }
        },
        {
            meta: { style: { width: "110px", minWidth: "110px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Stability</h3>
                </div>
            ),
            accessorKey: 'stabilityPercentage',
            cell: (row) => {
                const pct = row.row.original.stabilityPercentage;
                if (pct == null || pct === "") {
                    return <div className={classes.tableValueText}>—</div>;
                }
                const num = parseFloat(pct);
                const colour = num >= 90 ? "#27ae60" : num >= 70 ? "#e67e22" : "#c0392b";
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={colour}
                            PillColor_IfFalse={colour}
                            text_IfTrue={`${Math.round(num)}%`}
                            className={classes.PillHeight}
                        />
                    </div>
                );
            }
        },
        {
            meta: { style: { width: "90px", minWidth: "90px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Device</h3>
                </div>
            ),
            accessorKey: 'integrationType',
            cell: (row) => {
                let text = ""
                let colour = ""
                let textColour = ""
                switch (row.row.original.integrationType){
                    case "HIKVISION": 
                        text = "Hikvision"
                        colour = "#616366"
                        break;
                    case "DAHUA":
                        text = "Dahua"
                        colour = "#ee0018"
                        break;
                    case "AJAX": 
                        text = "AJAX"
                        colour = "#1a1a1aff"
                        break;
                    case "AIBOX":
                        text = "AIBox"
                        colour = "#00bbf8"
                        break;
                }
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        <Pill_Widget_2
                            pillColour={colour}
                            textColour={textColour}
                            text={text} 
                        />
                       
                    </div>
                )
            }
        },
        {
            meta: { style: { width: "160px", minWidth: "160px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Identifier</h3>
                </div>
            ),
            accessorKey: 'extraField1',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText} style={{ whiteSpace: "nowrap" }}>
                        {row.row.original.extraField1}
                    </div>
                )
            }
        },
        {
            meta: { style: { width: "120px", minWidth: "120px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Portal name</h3>
                </div>
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                        {row.row.original.tag && <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#919191"}
                            PillColor_IfFalse={"#6e6e6e"}
                            text_IfTrue={row.row.original.tag}
                            className={classes.PillHeight}
                        />}
                    </div>
                )
            }
        },
        {
            meta: { style: { width: "110px", minWidth: "110px" } },
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>App name</h3>
                </div>
            ),
            accessorKey: 'deviceName',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#C3B1E1"}
                                PillColor_IfFalse={"#626a67"}
                                text_IfTrue={row.row.original.deviceName}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        
        {
            meta: { style: { width: "80px", minWidth: "80px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Site ID</h3>
                </div>
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            meta: { style: { width: "110px", minWidth: "110px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Linked output</h3>
                </div>
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.pinName}
                    </div>
                )
            }
        },
        {
            meta: { style: { width: "170px", minWidth: "170px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Date linked</h3>
                </div>
            ),
            accessorKey: 'created_at',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.created_at)) || 
                !row.row.original.created_at 
                  ? row.row.original.created_at 
                  : format(new Date(row.row.original.created_at), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
            meta: { style: { width: "170px", minWidth: "170px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Offline since</h3>
                </div>
            ),
            accessorKey: 'missed_polls',
            cell: (row) => {
                const missedPolls = row.row.original.missed_polls;
                if (!missedPolls || missedPolls === 0) {
                    return <div className={classes.tableValueText}>—</div>;
                }
                const POLL_INTERVAL_MINUTES = 10;
                const offlineMs = missedPolls * POLL_INTERVAL_MINUTES * 60 * 1000;
                const offlineSinceDate = format(new Date(Date.now() - offlineMs), "MMMM do, yyyy - HH:mm");
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#c0392b"}
                            PillColor_IfFalse={"#c0392b"}
                            text_IfTrue={offlineSinceDate}
                            className={classes.PillHeight}
                        />
                    </div>
                );
            }
        },
        {
        meta: { style: { width: "120px", minWidth: "120px" } },
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Site owned by</h3>
            </div>
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={row.row.original.name !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            id: 'Active',
            meta: { style: { width: "90px", minWidth: "90px" } },
            header: () => (
                <div className={classes.tableTitleText}>
                <h3>Active site</h3>
                </div>
            ),
            filterLabel: "Active",
            accessorKey: 'active',
            cell: (row) => {
                const active = row.row.original.active == "1" ? true : false
                return (
                <div className={classes.tableValueText}>
                    <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)}/>
                </div>
                )
            }
        },
    ]

    
    return (
        <div className={`${classes.table} ${classes.center} `}>
            <ListCard secondaryClassName={classes["Card-container"]}>
                <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "5px 10px 0px 10px" }}>
                    <Await resolve={sites}>
                        {(loadedtableData) => {
                            const filteredData = loadedtableData.filter((item) =>
                                Object.values(item)
                                    .some(value => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
                            );

                            const pageSizeNum = Number(pageSize);
                            const pageCount = Math.max(1, Math.ceil(filteredData.length / pageSizeNum));
                            const safePageIndex = Math.min(pageIndex, pageCount);
                            const pagedData = filteredData.slice((safePageIndex - 1) * pageSizeNum, safePageIndex * pageSizeNum);

                            return (
                                <>
                                    <BasicTable
                                        data={pagedData}
                                        columns={tableColumns}
                                        filtering={""}
                                        rowClick={false}
                                        ShowPagination={false}
                                        PageSize={pageSizeNum}
                                        paginationOptions={[25, 50, 100]}
                                        showFilterButton={false}
                                        isSortable={false}
                                    />
                                    <GridPaginationControls
                                        pageIndex={safePageIndex}
                                        nextPage={() => setPageIndex(prev => Math.min(prev + 1, pageCount))}
                                        previousPage={() => setPageIndex(prev => Math.max(prev - 1, 1))}
                                        setPageIndex={(idx) => setPageIndex(Math.max(1, Math.min(Number(idx) || 1, pageCount)))}
                                        pageCount={pageCount}
                                        setPageSize={(size) => { setPageSize(Number(size)); setPageIndex(1); }}
                                        PageSize={pageSizeNum}
                                        PaginationOptions={[25, 50, 100]}
                                    />
                                </>
                            );
                        }}
                    </Await>
                </div>
            </ListCard>
        </div>
    );
}

export default CCTVIntegrationsList;